import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./CareerDetail.css";

import locationIcon from "../../assets/images/blue_location.png";
import jobTypeIcon from "../../assets/images/image_2022_08_29T06_31_19_245Z.png";
import experienceIcon from "../../assets/images/image_2022_08_29T06_31_19_243Z.png";
import salaryIcon from "../../assets/images/image_2022_08_29T06_31_19_240Z.png";
import dateIcon from "../../assets/images/Date To@2x.png";
import approvalIcon from "../../assets/images/Approval.png";

const jobInfo = [
  {
    icon: locationIcon,
    title: "Location",
    value: "Bengaluru",
  },
  {
    icon: jobTypeIcon,
    title: "Job type",
    value: "Full Time",
  },
  {
    icon: experienceIcon,
    title: "Experience",
    value: "4-5 Years",
  },
  {
    icon: salaryIcon,
    title: "Salary",
    value: "- as per candidate experience",
  },
  {
    icon: dateIcon,
    title: "Date posted",
    value: "15 March, 2023",
  },
];

const skills = [
  "Should have 4+ of experience in system/software solution development and delivery.",

  "Should be hands-on on Java, J2EE Frameworks, Spring MVC, Spring Boot.",

  "Should be hands-on on Microservices, Hibernate, RESTful Webservices, MySQL and Unix/Linux.",

  "Should have experience on deployments on cloud servers and should be ready to pick AWS cloud server deployment.",

  "Should possess good architectural knowledge and be aware of enterprise application design patterns.",

  "Worked on one or more projects in a production environment.",

  "Should have knowledge of Fintech",
];

const CareerDetail: React.FC = () => {
  return (
    <>

    <title>Finsall Job Role Details</title>
<meta
  name="description"
  content="View complete details of open roles at Finsall including responsibilities, experience requirements and growth opportunities in premium financing."
/>
      <Header />

      <main className="career-detail-page">
        <section className="career-detail-section">
          <div className="career-detail-container">

            <div className="career-detail-grid">

              {/* LEFT SIDE - JOB INFORMATION */}

              <div className="job-info-card">
                <div className="job-info-header">
                  <h2>Job Information</h2>
                </div>

                <div className="job-info-body">
                  {jobInfo.map((item, index) => (
                    <div
                      key={index}
                      className={`job-info-item ${
                        index === jobInfo.length - 1
                          ? "last-item"
                          : ""
                      }`}
                    >
                      <div className="job-info-icon">
                        <img
                          src={item.icon}
                          alt={item.title}
                        />
                      </div>

                      <div className="job-info-content">
                        <h4>{item.title}</h4>

                        <p>{item.value}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT SIDE CONTENT STARTS HERE */}

              <div className="career-content-card">

  <div className="career-role-section">
    <h2>Java Backend Developer Role at Finsall</h2>

    <p>
      Designing and developing end to end back end applications in java
      that meet the business requirements in an effective and efficient
      manner. Directly interfacing with the founding team and technology
      team to understand the requirements and provide solutions.
      Assisting & guiding team members in design and development.
    </p>
  </div>

  <div className="career-skills-section">
    <h3>
      Required Experience, Skills and Qualifications
    </h3>

    <div className="career-skills-list">

      {skills.map((skill, index) => (
        <div
          key={index}
          className="career-skill-item"
        >
          <img
            src={approvalIcon}
            alt="approval"
            className="career-skill-icon"
          />

          <span>{skill}</span>
        </div>
      ))}

    </div>
  </div>

  <div className="career-resume-section">
    <p>
      Send your Resume at{" "}
      <a href="mailto:hr@finsall.com">
        hr@finsall.com
      </a>
    </p>
  </div>

</div>
            </div>
            {/* END RIGHT CONTENT CARD */}

          </div>
          {/* END GRID */}
        </section>
      </main>

      <Footer />
    </>
  );
};

export default CareerDetail;